<template>
  <!--
    登入後發現帳號有一筆還在冷靜期的刪除申請：跳出提醒，可以一鍵取消（流程見 views/Member/AccountDeletion.vue）。
    送出刪除申請時所有裝置都會登出，所以「重新登入」就是會員反悔時最自然的路。
  -->
  <v-dialog v-model="show" max-width="400" persistent>
    <v-card class="pa-2">
      <v-card-title class="text-h6 font-weight-bold">你的帳號已申請刪除</v-card-title>
      <v-card-text class="text-body-1 text--primary">
        帳號將於 <b>{{ untilText }}</b> 刪除，屆時個人資料會被移除、無法復原。<br />
        如果改變主意，現在就可以取消。
      </v-card-text>
      <v-card-actions class="flex-wrap justify-end" style="gap: 8px">
        <v-btn text :disabled="cancelling" @click="dismiss">維持申請</v-btn>
        <v-btn color="primary" depressed :loading="cancelling" @click="cancelRequest">取消刪除申請</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { AccountDeletion_Get, AccountDeletion_Cancel } from "@/apis/api";

// 同一個分頁查過、沒有申請中的就不再查；按了「維持申請」也不再跳
const CHECKED_KEY = "taro_deletion_notice_checked";

export default {
  name: "DeletionPendingNotice",
  data() {
    return { show: false, until: null, cancelling: false };
  },
  computed: {
    untilText() {
      if (!this.until) return "";
      const d = new Date(this.until);
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
    },
  },
  watch: {
    "$store.state.signinStatus": {
      immediate: true,
      handler(signedIn) {
        if (signedIn) this.check();
        else this.show = false;
      },
    },
  },
  methods: {
    readChecked() {
      try {
        return sessionStorage.getItem(CHECKED_KEY) === "1";
      } catch (e) {
        return false;
      }
    },
    markChecked() {
      try {
        sessionStorage.setItem(CHECKED_KEY, "1");
      } catch (e) {
        /* 無痕模式存不了就每次查 */
      }
    },
    check() {
      // 刪除帳號那頁自己會顯示申請狀態，不用再跳
      if (this.readChecked() || this.$route.name === "AccountDeletion") return;
      AccountDeletion_Get()
        .then((res) => {
          const req = res.data && res.data.request;
          if (req && req.status === "CoolingOff") {
            this.until = req.coolingOffUntil;
            this.show = true;
          } else {
            this.markChecked();
          }
        })
        .catch(() => {});
    },
    dismiss() {
      this.show = false;
      this.markChecked();
    },
    cancelRequest() {
      this.cancelling = true;
      AccountDeletion_Cancel()
        .then(() => {
          this.show = false;
          this.markChecked();
          this.$notify({ content: "已取消刪除申請，帳號會繼續保留", status: "success" });
        })
        .catch(() => {
          this.$notify({ content: "取消失敗，請稍後再試", status: "error" });
        })
        .finally(() => {
          this.cancelling = false;
        });
    },
  },
};
</script>
